import * as React from 'react';

import type {ImportStatus as ImportStatusType} from 'nutshell-graphql-types';

import {TwoLine} from '../two-line/two-line';

import {
    getIconForStatus,
    buildButtonForStatusAndType,
    getHeaderForStatus,
    getBottomRowForStatusAndType,
} from './helpers';
import type {ImportType} from './types';

type Props = {
    type: ImportType;
    status: ImportStatusType;
    onRefresh: () => void;
    onViewEntity: () => void;
    count?: number;
    // replace default button text if set
    completedButtonText?: string | null | undefined;
};

export function ImportStatusBanner(props: Props) {
    return (
        <div className='flex border pad-16 br-3 justify-sb align-center background-white'>
            <div className='flex gap-16'>
                <div>{getIconForStatus(props.status)}</div>
                <TwoLine
                    topRow={getHeaderForStatus(props.status)}
                    bottomRow={getBottomRowForStatusAndType(
                        props.status,
                        props.type,
                        props.count || null
                    )}
                />
            </div>
            <div>
                {buildButtonForStatusAndType(
                    props.status,
                    props.type,
                    props.onRefresh,
                    props.onViewEntity,
                    props.completedButtonText
                )}
            </div>
        </div>
    );
}
